import { orderHistoryTableStyles as styles } from "@insite/content-library/Widgets/OrderHistory/OrderHistoryTable";
import getColor from "@insite/mobius/utilities/getColor";
import { colorStrings } from "@solveindustrial/Utilities/variables";
import { css } from "styled-components";

styles.reorderButton = {
    variant: "primary",
    sizeVariant: "small",
};

styles.dataTable = {
    ...styles.dataTable,
    css: css`
        ${styles.dataTable?.css}
        thead tr th {
            background-color: ${getColor(colorStrings.commonGlobalHeaderBg)};
            border: 0;

            span,
            button {
                color: ${getColor(colorStrings.commonGlobalWhite)};
            }
        }
        ,
        tr:nth-child(even) {
            background: transparent;
        }
        tr:nth-child(odd) {
            background: ${getColor(colorStrings.commonGlobalRowBg)};
        }

        td {
            border: 0;
        }
    `,
};
